import { render, staticRenderFns } from "./TransactionReferralEarning.vue?vue&type=template&id=fee99396&"
import script from "./TransactionReferralEarning.vue?vue&type=script&lang=ts&"
export * from "./TransactionReferralEarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports